import React, { useState } from "react";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import { useParams } from "react-router-dom";
import { fourPlaceHolder } from "modules/utilities/utility";
import {InboxOutlined   } from "@ant-design/icons";
import { useOrderDetailsStore } from "./store";
import SoftBadge from "modules/common/SoftBadge";
import OrderDetailsTable from "./OrderDetailsTable";

function OrderDetails() {
  const [show, setShow] = useState(false);
  const { orderData, orderLoading, fetchOrderData } = useOrderDetailsStore();
  const { id } = useParams();
  const handleClose = () => {
    setShow(false);
  };

  const handleShow = () => {
    setShow(true);
    fetchOrderData(id);
  };

  return (
    <>
      <div variant="primary" className="">
        <div className="d-flex ">
          <OverlayTrigger
            overlay={
              <Tooltip
                style={{ position: "fixed" }}
                id="overlay-trigger-example"
              >
                <div className="fw-bold">Order Details</div>
              </Tooltip>
            }
          >
            <div
              className="d-flex text-primary cursor-pointer fs-5 text-black"
              onClick={handleShow}
            >
              <InboxOutlined />
            </div>
          </OverlayTrigger>
        </div>
      </div>
      <Offcanvas
        show={show}
        onHide={handleClose}
        style={{ width: "70%" }}
        placement="end"
      >
        <Offcanvas.Header
          closeButton
          className="bg-light"
          style={{ zIndex: "999" }}
        >
          <Offcanvas.Title className="mb-n2">
            <div>
              <div className="">
                <span className="text-primary fw-bold">Order Details</span>
              </div>
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="mt-n3">
          {orderLoading ? (
            fourPlaceHolder()
          ) : (
            <div className="d-flex flex-column gap-2">
              <div className="d-flex flex-row gap-3 flex-wrap mt-1 shadow-sm rounded p-2 position-sticky top-0 bg-white">
                <div className="d-flex flex align-items-center">
                  <span className="fw-bold text-black">Actual Kit Count For User:</span>{" "}
                  <SoftBadge bg="primary" className="ms-2">
                    <span style={{ fontSize: "12px" }}>
                      {" "}
                      {orderData?.actualKitCountForUser}
                    </span>
                  </SoftBadge>
                  <span className="mx-2 fw-bold">|</span>
                </div>
                <div className="d-flex align-items-center">
                  <span className="fw-bold text-black">Total Order Count:</span>{" "}
                  <SoftBadge bg="primary" className="ms-1">
                    <span style={{ fontSize: "12px" }}>
                      {orderData?.totalOrderCount}
                    </span>
                  </SoftBadge>
                  <span className="mx-2 fw-bold">|</span>
                </div>
                <div className="d-flex align-items-center">
                  <span className="fw-bold text-black">Total Void Order Count :</span>{" "}
                  <SoftBadge bg="primary" className="ms-1">
                    <span style={{ fontSize: "12px" }}>
                      {" "}
                      {orderData?.totalVoidOrderCount}
                    </span>
                  </SoftBadge>
                  <span className="mx-2 fw-bold">|</span>
                </div>
                <div className="d-flex align-items-center">
                  <span className="fw-bold text-black">Void Kit Count</span>{" "}
                  <SoftBadge bg="primary" className="ms-1">
                    <span style={{ fontSize: "12px" }}>
                      {orderData?.voidKitCount}
                    </span>
                  </SoftBadge>
                  <span className="mx-2 fw-bold">|</span>
                </div>
                <div className="d-flex align-items-center">
                  <span className="fw-bold text-black">Total Non Void Order Count :</span>{" "}
                  <SoftBadge bg="primary" className="ms-1">
                    <span style={{ fontSize: "12px" }}>
                      {orderData?.totalNonVoidOrderCount}
                    </span>
                  </SoftBadge>
                  <span className="mx-2 fw-bold">|</span>
                </div>
                <div className="d-flex align-items-center">
                  <span className="fw-bold text-black">Single Void Order Count</span>{" "}
                  <SoftBadge bg="primary" className="ms-1">
                    <span style={{ fontSize: "12px" }}>
                      {orderData?.singleVoidOrderCount}
                    </span>
                  </SoftBadge>
                  <span className="mx-2 fw-bold">|</span>
                </div>
                <div className="d-flex align-items-center">
                  <span className="fw-bold text-black">Single Non-void Order Count</span>{" "}
                  <SoftBadge bg="primary" className="ms-1">
                    <span style={{ fontSize: "12px" }}>
                      {orderData?.singleNonVoidOrderCount}
                    </span>
                  </SoftBadge>
                  <span className="mx-2 fw-bold">|</span>
                </div>
                <div className="d-flex align-items-center">
                  <span className="fw-bold text-black">Non Void Kit Count</span>{" "}
                  <SoftBadge bg="primary" className="ms-1">
                    <span style={{ fontSize: "12px" }}>
                      {orderData?.nonVoidKitCount}
                    </span>
                  </SoftBadge>
                </div>
              </div>
              <OrderDetailsTable tableData={orderData?.orderDetails} />
            </div>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default OrderDetails;
